module.exports = __webpack_public_path__ + "img/light_11.4c74bb2c.png";